"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DialogBody: function() {
        return _DialogBody.DialogBody;
    },
    dialogBodyClassNames: function() {
        return _useDialogBodyStylesstyles.dialogBodyClassNames;
    },
    renderDialogBody_unstable: function() {
        return _renderDialogBody.renderDialogBody_unstable;
    },
    useDialogBodyStyles_unstable: function() {
        return _useDialogBodyStylesstyles.useDialogBodyStyles_unstable;
    },
    useDialogBody_unstable: function() {
        return _useDialogBody.useDialogBody_unstable;
    }
});
const _DialogBody = require("./DialogBody");
const _renderDialogBody = require("./renderDialogBody");
const _useDialogBody = require("./useDialogBody");
const _useDialogBodyStylesstyles = require("./useDialogBodyStyles.styles");
